// extracted by mini-css-extract-plugin
export default {"headerText":"OsCard_headerText__k5v10","text":"OsCard_text__Qp52j"};